import app from 'flarum/forum/app';
import on from './gate';
import { extend as extendComponent, override } from 'flarum/common/extend';
import Extend from 'flarum/common/extenders';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import CommentPost from 'flarum/forum/components/CommentPost';
import SongPicker from './SongPicker';
import ChallengeCard from './ChallengeCard';
import LearnPage from './LearnPage';
import LearnIndexPage from './LearnIndexPage';
import LearnSongBox from './LearnSongBox';
import AskLearnCard from './AskLearnCard';
import WeeklyChallenges from './WeeklyChallenges';
import LearnReadyNotification from './LearnReadyNotification';
import IndexPage from 'flarum/forum/components/IndexPage';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import LinkButton from 'flarum/common/components/LinkButton';
export const extend = [new Extend.Routes().add('challenges.index', '/learn', LearnIndexPage).add('challenges.learn', '/learn/:slug', LearnPage)];
// Calendar dates in SAST, including historic post badges (UTC storage).
export function day(started, at) {
  if (at === void 0) {
    at = new Date();
  }
  const date = new Date(started.replace(' ', 'T') + (/[Z+]\d*:?\d*$/.test(started) ? '' : 'Z'));
  const calendar = d => Math.floor((d.getTime() + 7200000) / 86400000);
  return Math.max(1, calendar(at) - calendar(date) + 1);
}
const selected = c => (c.composer.fields.tags || []).some(t => t.slug() === 'challenges');
app.initializers.add('noriods-challenges', () => {
  app.notificationComponents.challengeLearnReady = LearnReadyNotification; // registering is harmless; the server only sends it when the gate is on
  extendComponent('flarum/forum/components/DiscussionComposer', 'oninit', function () {
    if (!on()) return;
    this.composer.fields.challenge ??= {
      song: null,
      parts: ['rhythm'],
      hard_part: null
    };
  });
  extendComponent('flarum/forum/components/DiscussionComposer', 'headerItems', function (items) {
    if (!on()) return;
    if (selected(this)) items.add('challengeSong', m(SongPicker, {
      composer: this,
      state: this.composer.fields.challenge
    }), -20);
  });
  extendComponent('flarum/forum/components/DiscussionComposer', 'data', function (data) {
    if (!on()) return;
    const state = this.composer.fields.challenge;
    if (selected(this) && state?.song) data.challenge = {
      spotify_track_id: state.song.spotify_track_id,
      parts: state.parts,
      hard_part: state.hard_part
    };
  });
  override('flarum/forum/components/DiscussionComposer', 'onsubmit', function (original) {
    if (!on()) return original();
    if (selected(this) && !this.composer.fields.challenge?.song) {
      app.alerts.show({
        type: 'error'
      }, 'Pick your song before posting a challenge.');
      return;
    }
    return original();
  });
  extendComponent('flarum/forum/components/PostStream', 'view', function (vdom) {
    if (!on()) return;
    const challenge = this.discussion.attribute('gtChallenge');
    const song = this.discussion.attribute('gtLearnSong');
    let item = (challenge || song) && this.stream.visibleStart === 0 && vdom.children?.find(c => c?.attrs?.['data-index'] === 0);
    if (item?.tag === '[') item = item.children[0];
    if (Array.isArray(item?.children)) item.children.unshift(challenge ? m(ChallengeCard, {
      challenge: challenge
    }) : m(LearnSongBox, {
      song: song
    }));
  });
  extendComponent(CommentPost.prototype, 'headerItems', function (items) {
    if (!on()) return;
    const post = this.attrs.post;
    const c = post.discussion()?.attribute('gtChallenge');
    if (c && String(post.user()?.id()) === String(c.user_id) && post.number() > 1) items.add('challengeDay', m("span", {
      className: "Challenge-pill"
    }, "Day ", day(c.started_at, post.createdAt())), 85);
  });
  extendComponent(DiscussionListItem.prototype, 'infoItems', function (items) {
    if (!on()) return;
    const c = this.attrs.discussion.attribute('gtChallenge');
    if (c) {
      const d = day(c.started_at);
      items.add('challengeDay', m("span", {
        className: "Challenge-pill"
      }, d > 30 ? 'Finished' : `Day ${d}/30`), 80);
    }
  });
  extendComponent(IndexSidebar.prototype, 'navItems', function (items) {
    if (!on()) return;
    items.add('learn', m(LinkButton, {
      href: app.route('challenges.index'),
      icon: "fas fa-guitar",
      active: app.current.get('routeName')?.startsWith('challenges.')
    }, "Learn a song"), 90);
  });
  extendComponent(IndexSidebar.prototype, 'items', function (items) {
    if (!on()) return;
    if (app.current.get('routeName') === 'index') items.add('weeklyChallenges', m(WeeklyChallenges, null), -10);
  });
  extendComponent(IndexPage.prototype, 'contentItems', function (items) {
    if (!on()) return;
    if (app.current.get('routeName') === 'index') items.add('weeklyChallenges', m(WeeklyChallenges, {
      mobile: true
    }), 110);
  });
  // The optional Ask page exposes its component through its registered route.
  app.beforeMount(() => {
    const AskPage = app.routes['ask.show']?.component;
    if (AskPage?.prototype?.renderAnswer) extendComponent(AskPage.prototype, 'renderAnswer', function (vnode, answer) {
      if (!on()) return;
      if (Array.isArray(vnode.children)) vnode.children.push(m(AskLearnCard, {
        answer: answer
      }));
    });
  });
});